import { Component, signal, OnInit } from '@angular/core';
import { TranslationService } from './services/translation.service';
import { LangService } from './services/lang.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
  standalone: false
})
export class AppComponent implements OnInit {
  protected readonly title = signal('echo-office');

  constructor(
    private translationService: TranslationService,
    private langService: LangService
  ) {}

  ngOnInit(): void {
    // Initialize language and translations
    const currentLang = this.langService.getCurrentLang();
    this.translationService.loadTranslations(currentLang);
  }
}
